import React from "react";
import { PermitApplicationContext, DEFAULT_PERMIT_APPLICATION_CONTEXT } from "./PermitApplicationContext";
import { IPermitApplicationContext } from "./types";

/**
 * Returns the PermitApplicationContext injected by a PermitApplicationProvider.
 * Throws an error if used outside of a PermitApplicationProvider tree.
 */
export const usePermitApplicationContext = (): IPermitApplicationContext => {
  const context = React.useContext(PermitApplicationContext);

  if (context === DEFAULT_PERMIT_APPLICATION_CONTEXT) {
    throw new Error("usePermitApplicationContext was used outside of a PermitApplicationProvider");
  }

  return context;
};

export default usePermitApplicationContext;
